import annotations from './modules/annotations';
import auth from './modules/auth';
import counterpoint from './modules/counterpoint';
import document from './modules/document';
import general from './modules/general';
import geometries from './modules/geometries';
import hover from './modules/hover';
import organization from './modules/organization';
import outline from './modules/outline';
import team from './modules/team';
import user from './modules/user';
import logger from './modules/logger';
import share from './modules/share';
import status from './modules/status';

export default {
  ...annotations.actions,
  ...auth.actions,
  ...counterpoint.actions,
  ...document.actions,
  ...general.actions,
  ...geometries.actions,
  ...hover.actions,
  ...organization.actions,
  ...outline.actions,
  ...team.actions,
  ...user.actions,
  ...share.actions,
  ...status.actions,
  ...logger.actions,
};
